export default [
    {
        name: 'Contratações',
        url: '/credenciados/gerentes/contratacoes',
        icon: 'fa fa-book',
        badge: {
            variant: 'primary',
            text: 'GERENTE'
        },
        regras: 'CRED-GER-CONT-00'
    },
    {
        name: 'Entregas',
        url: '/credenciados/gerentes/entregas',
        icon: 'fa fa-truck',
        badge: {
            variant: 'primary',
            text: 'GERENTE'
        },
        regras: 'CRED-GER-ENTR-00'
    },
    {
        name: 'Equipe de Apoio',
        url: '/credenciados/gerentes/apoios',
        icon: 'fa fa-users',
        regras: 'CRED-GER-APOIO-00'
    },
    {
        name: 'Designação de Gestores',
        url: '/credenciados/gerentes/gestoresdesignados',
        icon: 'fa fa-users',
        regras: 'CRED-GER-GEST-00'
    },
    {
        name: 'Reaberturas de Entregas',
        url: '/credenciados/gerentes/solicitacoesreaberturas',
        icon: 'fa fa-refresh',
        regras: 'CRED-GER-ENTR-02'
    }
]
